import { appealApi } from 'feature/appeals/redux/appeals.api'
import { useSetNotice } from 'hooks/useSetNotice'
import { useState } from 'react'
import { useNavigate } from 'react-router'
import { useActions, useAppSelector, useThunkDispatch } from 'store/hooks'
import { Severity } from 'widget/Notifications'

import { ordersApi, useSendConsultFormMutation } from '../redux/orders.api'

export const useSendConsultForm = () => {
  const currentEdit = useAppSelector(
    state => state.orderForm.currentEditConsultForm,
  )
  const currentForm = useAppSelector(
    state => state.orderForm.consultationForms[currentEdit],
  )
  const [isError, setIsError] = useState(false)
  const [sendConsultForm] = useSendConsultFormMutation()
  const setNotice = useSetNotice()
  const navigate = useNavigate()
  const thunkDispatch = useThunkDispatch()
  const { setDefaultConsultFormData } = useActions()

  const sendForm = () => {
    setIsError(false)
    const formData = {
      comment: currentForm.comment,
      fileList: currentForm.images.map(item => item.serverUid) as string[],
      productTypeList: currentForm.products?.map(item => item.id),
    }
    sendConsultForm({ data: formData, type: currentEdit })
      .unwrap()
      .then(() => {
        setDefaultConsultFormData()
        thunkDispatch(ordersApi.util.resetApiState())
        thunkDispatch(appealApi.util.resetApiState())
        navigate('/appeals')
      })
      .catch(error => {
        setIsError(true)
        if (error.status === 401 || error.status === 423) {
          return
        }
        thunkDispatch(ordersApi.util.resetApiState())
        setNotice(error.data.message, Severity.error)
      })
  }

  return { isError, sendForm }
}
